<div class="dxp-sriwijaya">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 my-md-5 mb-5 sec-title">
                <app-title-page [dataTitle]="dataTitle" [link]="'#prod-sriwijaya'"></app-title-page>
            </div>
            <!-- contents -->
            <div class="col-md-12 sec-contents list-circle padlist no-list" id="prod-sriwijaya">
                <div class="lane-top pt-5">
                    <div class="desc text-justify" [innerHTML]="dataSection[0]?.content"></div>
                    <div class="bg-headline my-5 w-100" [ngStyle]="{'background-image' : 'url('+ apiAsset + dataSection[0]?.picture +')'}">
                    </div>
                     <div class="desc text-justify" [innerHTML]="dataSection[1]?.content"></div>
                     <div class="seeds my-5" *ngIf="dataSection[1]?.card.length != 0">
                        <div class="row">
                            <div class="col-xl-10 col-lg-11 col-md-12 col-sm-10 mx-auto">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="w-seed h-100 text-center pb-1">
                                            <div class="mini-tit py-1 px-3">
                                                <h6 class="mb-0">{{ dataSection[1]?.card[0].title }}</h6>
                                            </div> 
                                            <div class="total pt-4" [innerHTML]="dataSection[1]?.card[0].description"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mt-md-0 mt-5">
                                        <div class="w-seed h-100 text-center pb-1">
                                            <div class="mini-tit py-1 px-3">
                                                <h6 class="mb-0">{{ dataSection[1]?.card[1].title }}</h6>
                                            </div> 
                                            <div class="total pt-4" [innerHTML]="dataSection[1]?.card[1].description"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="desc text-justify" [innerHTML]="dataSection[2]?.content"></div>
                    <div class="visit mt-5">
                        <p>{{ isLang?.visit }}:</p>
                        <div class="row mt-3">
                            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-9 mx-md-0 mx-auto ">
                                <a href="http://www.binasawitmakmur.com/" target="_blank" class="btn red-btn-icon w-100">
                                    PT Binasawit Makmur
                                    <img class="ic-arr" src="../../../../assets/images/icon/arrow-left-white.svg" alt="">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</div>
